// extracted by mini-css-extract-plugin
export default {"Card":"AverageDurationCard_Card__X-o7M"};